<template>
  <div class="nocode-page">
    <!-- Header with gradient -->
    <header class="header">
      <div class="header-content">
        <h1 class="main-title">Our No Code agency services</h1>
        <p class="subtitle">Cost-effective digital solutions for rapid business transformation</p>
      </div>
    </header>

    <div class="content-container">
      <!-- Introduction - Part 1 -->
      <section class="card intro-card">
        <div class="card-content">
          <h2 class="section-title">Modernize through our No Code expertise</h2>
          <div class="text-and-illustration">
            <div class="text-content">
              <p>
                ✓ <strong><i>Creativity and innovation, to reinvent your brand on the web</i></strong> : To ensure that your project is always at the forefront of the latest digital developments, we constantly explore new ideas and approaches. Creating unique and customized digital solutions for your audience is our passion.
              </p><br>
              <p>
                ✓ <strong><i>Concrete results, your success is our reward</i></strong> : Our ultimate goal is to generate tangible results to boost your online identity. Whether in terms of visibility thanks to our SEO expertise or the realization of your ideas through our no code / low code solutions, your success is our greatest reward.
              </p><br>
              <p>
                ✓ <strong><i>Our expertise at your service</i></strong> : After more than a decade of evolving in the digital world, our team develops your project with a constantly renewed technical arsenal.
              </p>
            </div>
            <div class="hero-illustration">
              <div class="dashboard-preview">
                <iframe
                  style="width: 100%; height: 100%; border: none; border-radius: 15px;"
                  src="https://www.youtube.com/embed/ctSvq3kxSWY"
                  title="Presentation of our No Code solutions"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen>
                </iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Introduction - Part 2 -->
      <section class="card intro-card-2">
        <div class="card-content">
          <h2 class="section-title">Grow your business with the LCTD method : Listening, Collaboration, Targets, Data</h2>
          <div class="text-content">
            <p>
              ✓ <strong><i>A tailored strategy centered on listening</i></strong> : At Web Passion, every project begins with understanding and defining your objectives. We believe in a personalized approach where we immerse ourselves in your brand, your target audience, and your industry. This allows us to design personalized strategies with tangible results in sight.
            </p><br>
            <p>
              ✓ <strong><i>Management in close collaboration</i></strong>: You are at the heart of our work. Indeed, you are considered as partners. Your vision, your ideas, and your concerns are central to every decision made. That's why we work closely with you at every step of the process to ensure that the project evolves in harmony with your expectations.
            </p><br>
            <p>
              ✓ <strong><i>Data, the secret to success</i></strong> : Our decisions are not based on assumptions but on facts. Thus, concrete data is used to guide strategies and obtain concrete results. We collect and perform an in-depth analysis of the data obtained, whether it's your business, that of your competitors, or your field of activity.
            </p>
          </div>
        </div>

        <div align="center">
          <a href="https://www.web-passion.fr/prestations-no-code/" target="_blank"
            style="display: block; width: fit-content; margin: 0 auto; background-color: #7c3aed1a; color: inherit; padding: 10px; border-radius: 9999px;">
            <strong>Learn more about our No Code services</strong>
          </a><br>
        </div>

      </section>

      <!-- Main Services -->
      <section class="card services-card">
        <div class="card-content">
          <h2 class="section-title">What No Code solutions can we create to accelerate your digital transformation ?</h2>
          
          <!-- Advantages (Cards) -->
          <div class="advantages-grid">
            <!-- Service 1 -->
            <div class="advantage-card">
              <div class="advantage-number">1</div>
              <h3 class="advantage-title">Custom development</h3>
              <p class="advantage-description">
                We create your custom business applications, 
                your websites (showcase, e-commerce), install your CRM and adapted ERPs, develop your marketplaces, 
                your mobile applications, and your dashboards to visualize your data.
              </p>
            </div>
  
            <!-- Service 2 -->
            <div class="advantage-card">
              <div class="advantage-number">2</div>
              <h3 class="advantage-title">Process optimization & automation</h3>
              <p class="advantage-description">
                We automate your repetitive and time-consuming tasks, centralize your information,
                reduce the necessary resources, simplify your workflows, and
                make your teams' work easier for better efficiency.
              </p>
            </div>
  
            <!-- Service 3 -->
            <div class="advantage-card">
              <div class="advantage-number">3</div>
              <h3 class="advantage-title">Consulting & support</h3>
              <p class="advantage-description">
                Our offer includes auditing and diagnosing your needs, training
                and tool onboarding, providing experts on a shared-time basis,
                maintenance, support, and regular performance monitoring of all your No-Code solutions.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- Advantages and Benefits -->
      <section class="card benefits-card">
        <div class="card-content">
          <h2 class="section-title">How can No Code help you develop your digital projects ?</h2>
          
          <div class="advantages-grid">
            <!-- Advantage 1 -->
            <div class="advantage-card">
              <div class="advantage-number">1</div>
              <h3 class="advantage-title">Higher development speed</h3>
              <p class="advantage-description">
                Create prototypes and functional solutions quickly. Complete your projects
                in weeks instead of months.
              </p>
            </div>
  
            <!-- Advantage 2 -->
            <div class="advantage-card">
              <div class="advantage-number">2</div>
              <h3 class="advantage-title">Drastic cost reduction</h3>
              <p class="advantage-description">
                Save up to 75% compared to traditional development,
                without hiring developers, for a quick and tangible ROI.
              </p>
            </div>
  
            <!-- Advantage 3 -->
            <div class="advantage-card">
              <div class="advantage-number">3</div>
              <h3 class="advantage-title">Flexibility and agility</h3>
              <p class="advantage-description">
                Make changes and evolutions easily and quickly. Develop
                solutions progressively with an iterative and agile approach.
              </p>
            </div>
  
            <!-- Advantage 4 -->
            <div class="advantage-card">
              <div class="advantage-number">4</div>
              <h3 class="advantage-title">100% team autonomy</h3>
              <p class="advantage-description">
                Benefit from solutions that are easy to handle, with intuitive interfaces.
                Your teams will be 100% autonomous after training.
              </p>
            </div>
  
            <!-- Advantage 5 -->
            <div class="advantage-card">
              <div class="advantage-number">5</div>
              <h3 class="advantage-title">Considerable time savings</h3>
              <p class="advantage-description">
                Save up to a week of work per month per employee. Reduce the 10 hours
                lost per week searching for information and automate repetitive manual tasks.
              </p>
            </div>
  
            <!-- Advantage 6 -->
            <div class="advantage-card">
              <div class="advantage-number">6</div>
              <h3 class="advantage-title">100% customized solutions</h3>
              <p class="advantage-description">
                Create solutions precisely adapted to your business needs with complex functionalities
                (databases, workflows) and integration with your existing tools.
              </p>
            </div>
          </div>
        </div>
      </section>

      <!-- Technical Expertise -->
      <section class="card expertise-card">
        <div class="card-content">
          <h2 class="section-title">Our technical skills and toolkit to transform your vision into reality</h2>
          <div class="text-content">
            <p>
              In our agency, No Code consultants master a wide range of specialized tools that allow us
              to create solutions adapted to all your needs. Our technical expertise
              covers all application areas of No Code.
            </p>
          </div>
          
          <div class="tools-container">
            <h3 class="subsection-title">Mastered tools</h3>
            <div class="tools-grid">
              <span class="tool-tag">Ksaar</span>
              <span class="tool-tag">Make</span>
              <span class="tool-tag">Softr</span>
              <span class="tool-tag">Notion</span>
              <span class="tool-tag">Glide</span>
              <span class="tool-tag">Bubble</span>
              <span class="tool-tag">Airtable</span>
              <span class="tool-tag">Webflow</span>
              <span class="tool-tag">Zapier</span>
              <span class="tool-tag">Power Apps</span>
              <span class="tool-tag">HubSpot</span>
              <span class="tool-tag">Slack</span>
              <span class="tool-tag">Brevo</span>
              <span class="tool-tag">GPT</span>
              <span class="tool-tag">Salesforce</span>
            </div>
            
            <h3 class="subsection-title">Application domains</h3>
            <div class="domains-grid">
              <span class="domain-tag">CRM</span>
              <span class="domain-tag">ERP</span>
              <span class="domain-tag">Automation</span>
              <span class="domain-tag">Websites</span>
              <span class="domain-tag">Business Applications</span>
              <span class="domain-tag">Data Management</span>
            </div>
          </div>
        </div>
      </section>

      <!-- Methodology -->
      <section class="card methodology-card">
      <div class="card-content">
          <h2 class="section-title">A methodology that adjusts to your needs and objectives</h2>
          <div class="methodology-flow">
          <!-- Step 1 - Qualification -->
          <div class="method-step">
              <div class="step-circle">
              <div class="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M10 17l-5-5 5-5M18 17l-5-5 5-5" stroke-linecap="round" stroke-linejoin="round" transform="rotate(220 12 12)"></path>
                  </svg>
              </div>
              </div>
              <h3>Qualification</h3>
              <p>Initial diagnosis</p>
          </div>
          
          <!-- Step 2 - Analysis -->
          <div class="method-step">
              <div class="step-circle purple">
              <div class="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 3v18h18" stroke-linecap="round" stroke-linejoin="round"></path>
                  <path d="M7 14l3-3 4 4 5-5" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
              </div>
              </div>
              <h3>Analysis</h3>
              <p>Solution design</p>
          </div>
          
          <!-- Step 3 - Development -->
          <div class="method-step">
              <div class="step-circle">
              <div class="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M8 9l3 3-3 3M16 9l-3 3 3 3" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
              </div>
              </div>
              <h3>Development</h3>
              <p>Tool configuration</p>
          </div>
          
          <!-- Step 4 - Launch -->
          <div class="method-step">
              <div class="step-circle purple">
              <div class="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
              </div>
              </div>
              <h3>Launch</h3>
              <p>Tests and production</p>
          </div>
          
          <!-- Step 5 - Training -->
          <div class="method-step">
              <div class="step-circle">
              <div class="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M12 2v6M12 18v4M4.93 4.93l4.24 4.24M14.83 14.83l4.24 4.24M2 12h6M16 12h6M4.93 19.07l4.24-4.24M14.83 9.17l4.24-4.24" stroke-linecap="round"></path>
                  </svg>
              </div>
              </div>
              <h3>Training</h3>
              <p>Support</p>
          </div>
          
          <!-- Step 6 - Maintenance -->
          <div class="method-step">
              <div class="step-circle purple">
              <div class="step-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="3" stroke-linecap="round" stroke-linejoin="round"></circle>
                  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
              </div>
              </div>
              <h3>Maintenance</h3>
              <p>Continuous evolution</p>
          </div>
          </div>
      </div>
      </section>

      <!-- Client testimonials -->
      <section class="testimonials-section">
        <h2 class="testimonials-title">What our clients say</h2>
        
        <div class="testimonials-container">
          <!-- Testimonial 1 -->
          <div class="testimonial-card">
            <div class="testimonial-header">
              <div class="client-info">
                <h3 class="client-name">Rémi D.</h3>
                <p class="client-company">Trainer</p>
                <div class="rating">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
              </div>
            </div>
            <div class="testimonial-body">
              <p>I called on Arynae to create automation. 
              The tool perfectly meets our needs, automatically generating customized documents 
              and sending them to clients. The process is reliable and has considerably 
              reduced our administrative burden. Their team took the time to understand our document templates 
              and our sending criteria, which allowed for an efficient implementation.
              </p>
            </div>
            <div class="testimonial-border"></div>
          </div>
          
          <!-- Testimonial 2 -->
          <div class="testimonial-card">
            <div class="testimonial-header">
              <div class="client-info">
                <h3 class="client-name">Martin R.</h3>
                <p class="client-company">Customer Service Director</p>
                <div class="rating">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
              </div>
            </div>
            <div class="testimonial-body">
              <p>The No Code tourist itineraries application developed by Arynae complements our travel 
                advisory services well. It allows our clients to calculate 
                optimized itineraries and receive personalized recommendations of places to visit. 
                I particularly appreciate the ease with which we can update the attractions database. 
                Our travelers are delighted, and we have 98% positive feedback.
                </p>
            </div>
            <div class="testimonial-border"></div>
          </div>
          
          <!-- Testimonial 3 -->
          <div class="testimonial-card">
            <div class="testimonial-header">
              <div class="client-info">
                <h3 class="client-name">Camille D.</h3>
                <p class="client-company">Web Marketing Director</p>
                <div class="rating">
                  <span>★</span><span>★</span><span>★</span><span>★</span><span>★</span>
                </div>
              </div>
            </div>
            <div class="testimonial-body">
              <p>The newsletter registration form connected to our No Code database and 
                our CRM has allowed us to gain 30% new readers. 
                Synchronization with our existing system works smoothly. 
                I highly recommend this agency for their professionalism and ability to deliver a 
                customized solution that precisely meets our marketing needs.
              </p>
            </div>
            <div class="testimonial-border"></div>
          </div>
        </div>
        
        <div class="dots-navigation">
          <span class="dot active"></span>
          <span class="dot"></span>
          <span class="dot"></span>
        </div>
      </section>

      <!-- Call to action -->
      <div class="cta-container">
        <span class="cta-button fake-link" @click="navigateTo('e1')">Schedule an online / phone / video appointment</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useHead } from '@vueuse/head'

export default {
  name: 'NoCodeServicePage',
  setup() {
    useHead({
      title: 'No Code solutions - Codeless application development | Arynae',
      meta: [
        { name: 'description', content: 'Creation of applications and websites without coding. Our No Code solutions allow you to quickly develop functional and professional platforms at a lower cost.' },
        { name: 'keywords', content: 'no code, low code, codeless development, no code applications, websites without programming, bubble, webflow, airtable, zapier, Arynae' },
        { name: 'robots', content: 'index, follow' },
        { name: 'author', content: 'Arynae' },
        { 'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8' },
        // Essential Open Graph
        { property: 'og:type', content: 'website' },
        { property: 'og:title', content: 'No Code solutions - Codeless application development | Arynae' },
        { property: 'og:description', content: 'Creation of applications and websites without coding. Our No Code solutions allow you to quickly develop functional and professional platforms at a lower cost.' },
        { property: 'og:url', content: 'https://arynae.com/en/nocode' },
        { property: 'og:locale', content: 'en_US' },
        { property: 'og:image', content:'https://arynae.com/img/arynae-social-card.png' },
        { property: 'og:image:alt', content:'Digital agency - No Code solutions, SaaS, Chatbots & SEO' },
        // Basic Twitter Card
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: 'No Code solutions - Codeless application development | Arynae' },
        { name: 'twitter:description', content: 'Creation of applications and websites without coding. Our No Code solutions allow you to quickly develop functional and professional platforms at a lower cost.' },
        { name: 'twitter:image', content: 'https://arynae.com/img/arynae-social-card.png' },
        { name: 'viewport', content: 'width=device-width, initial-scale=1.0' }
      ],
      link: [
        { rel: 'canonical', href: 'https://arynae.com/en/nocode' },
        { rel: 'alternate', hreflang: 'fr', href: 'https://arynae.com/nocode' },
        { rel: 'alternate', hreflang: 'en', href: 'https://arynae.com/en/nocode' }
      ],
      htmlAttrs: {
        lang: 'en'
      }
    })
    
    return {}
  },
  data() {
    return {}
  },
  methods: {
    navigateTo(code) {
      const routes = {
        'e1': 'https://cal.com/web-passion/rdv'
      };
      
      window.open(routes[code] || code, '_blank');
    }
  }
}
</script>

<style scoped>
.nocode-page {
  font-family: Arial, sans-serif;
  color: #333;
}

/* Header Styles */
.header {
  background: linear-gradient(to right, #2563EB, #7C3AED);
  padding-bottom: 6rem;
  color: white;
}

.header-content {
  text-align: center;
  padding: 5rem 2rem 3rem;
}

.main-title {
  font-size: 2.75rem;
  margin-bottom: 1rem;
}

.subtitle {
  font-size: 1.25rem;
  max-width: 800px;
  margin: 0 auto;
}

/* Content Container */
.content-container {
  max-width: 1200px;
  margin: -3rem auto 4rem;
  padding: 0 2rem;
}

/* Card Styles */
.card {
  background: linear-gradient(to bottom, #ffffff, #f3f4f6);
  border-radius: 0.5rem;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 2rem;
  overflow: hidden;
}

.card-content {
  padding: 2rem;
}

.section-title {
  font-size: 1.75rem;
  margin-bottom: 1.5rem;
  color: #333;
  display: block;
}

.subsection-title {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #555;
  text-align: center;
}

.text-content {
  font-size: 1rem;
  line-height: 1.6;
  color: #555;
}

/* Intro Card with Illustration */
.text-and-illustration {
  display: flex;
  flex-wrap: wrap;
  gap: 2rem;
}

.text-and-illustration .text-content {
  flex: 1;
  min-width: 280px;
}

/* Hero illustration and dashboard preview */
.hero-illustration {
  flex: 1;
  min-width: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.dashboard-preview {
  width: 100%;
  height: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Advantages Grid */
.advantages-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 2rem;
  margin: 3rem 0;
}

.advantage-card {
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 2rem;
  position: relative;
}

.advantage-number {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(to right, #4158D0, #C850C0);
  color: white;
  font-size: 1.25rem;
  font-weight: bold;
  margin-bottom: 1rem;
}

.advantage-title {
  font-size: 1.25rem;
  margin-bottom: 1rem;
  color: #333;
}

.advantage-description {
  font-size: 0.875rem;
  line-height: 1.6;
  color: #555;
}

/* Tools section */
.tools-container {
  margin-top: 2rem;
}

.tools-grid, .domains-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  justify-content: center;
  margin: 1.5rem 0 2.5rem;
}

.tool-tag {
  background: linear-gradient(to right, #4158D0, #7C3AED);
  color: white;
  font-weight: bold;
  padding: 0.5rem 1rem;
  border-radius: 2rem;
  font-size: 0.9rem;
}

.domain-tag {
  background: linear-gradient(to right, #C850C0, #7C3AED);
  color: white;
  font-weight: bold;
  padding: 0.75rem 1.5rem;
  border-radius: 2rem;
  font-size: 1rem;
}

/* Methodology section */
.methodology-steps {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: 2rem;
  margin-top: 2rem;
}

.methodology-step {
  text-align: center;
  flex: 0 1 150px;
}

.step-number {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: linear-gradient(to right, #4158D0, #C850C0);
  color: white;
  font-size: 1.25rem;
  font-weight: bold;
  margin: 0 auto 1rem;
}

.methodology-step h3 {
  font-size: 1.1rem;
  margin-bottom: 0.5rem;
  color: #333;
}

.methodology-step p {
  font-size: 0.9rem;
  color: #555;
}

/* Testimonials Section */
.testimonials-container {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  padding: 1rem;
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  overflow-x: auto;
  padding-bottom: 1rem; /* Espace pour la scrollbar */
}

.testimonial-card {
  flex: 0 0 calc(33.333% - 1.5rem);
  min-width: 280px;
  background: white;
  border-radius: 16px;
  position: relative;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04), 0 0 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* Cache la scrollbar sur certains navigateurs mais garde la fonctionnalité */
.testimonials-container::-webkit-scrollbar {
  height: 6px;
}

.testimonials-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}

.testimonials-container::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.05);
}

@media (max-width: 768px) {
  .testimonials-container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

.dots-navigation {
  display: none;
}

.dots-navigation {
  display: none; /* Cache les points s'ils ne sont pas nécessaires */
}

@media (max-width: 992px) {
  .testimonials-container {
    flex-direction: column;
    padding: 1rem;
    gap: 2rem;
  }
  
  .testimonial-card {
    width: 100%;
    margin-bottom: 1rem;
  }
}

.dots-navigation {
display: none; /* Cache les points s'ils ne sont pas nécessaires */
}


.testimonials-container {
  display: flex;
  gap: 2rem;
  padding: 1rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
  overflow-x: visible;
}

.testimonial-card:hover {
transform: translateY(-8px);
box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08), 0 0 12px rgba(0, 0, 0, 0.06);
}

.testimonial-header {
display: flex;
align-items: center;
padding: 1.5rem 1.5rem 0.5rem;
}

.client-info {
flex: 1;
}

.client-name {
font-size: 1.25rem;
font-weight: 700;
margin: 0 0 0.25rem;
color: #1a202c;
}

.client-company {
font-size: 0.9rem;
color: #718096;
margin: 0 0 0.5rem;
}

.rating {
display: flex;
font-size: 1.1rem;
color: #FFC107;
}

.testimonial-body {
padding: 0.5rem 1.5rem 2rem;
font-size: 1rem;
line-height: 1.7;
color: #4A5568;
flex: 1;
}

.testimonial-border {
height: 5px;
background: linear-gradient(90deg, #2563EB, #7C3AED, #EC4899);
width: 100%;
}

.dots-navigation {
display: flex;
justify-content: center;
gap: 0.5rem;
margin-top: 2.5rem;
}

.dot {
width: 10px;
height: 10px;
border-radius: 50%;
background-color: #CBD5E0;
cursor: pointer;
transition: all 0.3s ease;
}

.dot:hover {
background-color: #A0AEC0;
}

.dot.active {
background: linear-gradient(90deg, #2563EB, #7C3AED);
width: 30px;
border-radius: 10px;
}

/* Media queries pour responsive */
@media (max-width: 768px) {
.testimonials-container {
  padding: 1rem;
  flex-direction: column;
  gap: 2rem;
}

.testimonial-card {
  min-width: 100%;
}

.testimonials-title {
  font-size: 2rem;
  margin-bottom: 2.5rem;
}
}

.client-name {
  font-weight: bold;
  font-style: normal;
  margin-top: 1rem;
}

/* Call to Action */
.cta-container {
  text-align: center;
  margin: 3rem 0;
}

.cta-button {
  background: linear-gradient(to right, #4158D0, #C850C0);
  color: white;
  font-size: 1.25rem;
  font-weight: bold;
  padding: 1rem 2.5rem;
  border: none;
  border-radius: 2rem;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: inline-block;
  max-width: 100%;
  word-wrap: break-word;
  text-align: center; /* Cette propriété assure que le texte est centré sur plusieurs lignes */
}

@media (max-width: 768px) {
  .cta-button {
    font-size: 1rem;
    padding: 0.8rem 1.5rem;
    width: 90%;
  }
}


/* Special styling for intro cards */
.intro-card, .intro-card-2 {
  margin-bottom: 1.5rem;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .header-content {
    padding: 4rem 1rem 2rem;
  }
  
  .main-title {
    font-size: 2rem;
  }
  
  .content-container {
    padding: 0 1rem;
  }
  
  .advantages-grid {
    grid-template-columns: 1fr;
  }
  
  .text-and-illustration {
    flex-direction: column;
  }
  
  .text-and-illustration .text-content {
    order: 1;
    width: 100%;
    min-width: 100%;
  }
  
  .hero-illustration {
    order: 2;
    min-width: 0;
    width: 100%;
    margin-bottom: 1.5rem;
  }
  
  .youtube-container {
    height: 200px;
  }
  
  .dashboard-preview {
    height: 200px;
    width: 100%;
    position: relative;
    padding-bottom: 56.25%;
  }
  
  .dashboard-preview iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  
  /* Intro Card - Fix pour la section intro */
  .intro-card .text-and-illustration {
    flex-direction: column;
  }
  
  .intro-card .text-content {
    width: 100%;
    min-width: 100%;
    order: 1;
    margin-bottom: 1rem;
  }
  
  .intro-card .hero-illustration {
    width: 100%;
    min-width: 100%;
    order: 2;
  }
  
  .intro-card .section-title {
    font-size: 1.5rem;
    text-align: center;
  }
  
  .methodology-steps {
    flex-direction: column;
    align-items: center;
  }
  
  .methodology-step {
    flex: 0 1 auto;
    width: 100%;
    max-width: 200px;
  }
}


/* Méthodologie flow style moderne */
.methodology-flow {
display: flex;
flex-wrap: wrap;
justify-content: center;
gap: 1rem;
margin: 3rem 0 1rem;
position: relative;
}

.methodology-flow:before {
content: '';
position: absolute;
top: 40px;
left: 10%;
width: 80%;
height: 3px;
background: linear-gradient(to right, #E2E8F0, #E2E8F0 50%, transparent 50%, transparent);
background-size: 20px 3px;
z-index: 0;
}

.method-step {
flex: 0 1 140px;
display: flex;
flex-direction: column;
align-items: center;
text-align: center;
z-index: 1;
}

.step-circle {
width: 80px;
height: 80px;
border-radius: 50%;
background: linear-gradient(to right, #4158D0, #4D5DFA);
display: flex;
justify-content: center;
align-items: center;
margin-bottom: 1rem;
box-shadow: 0 4px 10px rgba(65, 88, 208, 0.3);
}

.step-circle.purple {
background: linear-gradient(to right, #7C3AED, #C850C0);
box-shadow: 0 4px 10px rgba(124, 58, 237, 0.3);
}

.step-icon {
width: 40px;
height: 40px;
color: white;
display: flex;
justify-content: center;
align-items: center;
}

.method-step h3 {
font-size: 1.1rem;
margin-bottom: 0.25rem;
color: #333;
}

.method-step p {
font-size: 0.9rem;
color: #555;
margin: 0;
}

@media (max-width: 768px) {
.methodology-flow {
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.methodology-flow:before {
  width: 3px;
  height: 80%;
  top: 10%;
  left: 50%;
  background: linear-gradient(to bottom, #E2E8F0, #E2E8F0 50%, transparent 50%, transparent);
  background-size: 3px 20px;
}

.method-step {
  width: 100%;
  max-width: 200px;
}
}

</style>